<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Usuario" />

    <CreateUser />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreateUser from "@/components/Pages/Configuration/Users/view.vue";

export default defineComponent({
  name: "CreateUserPage",
  components: {
    PageTitle,
    CreateUser,
  },
});
</script>
